import React from 'react'

export const tradeInCategoryConfig = [
  {
    categoryIds: ['29959'], // Mobile phones and accessories
    excludedCategoryIds: ['30144'], // smart watches
    heading: 'Trade in your old phone.',
    subtext: (
      <>
        Receive between <strong>£19 - £320.</strong> Get your estimated value here.
      </>
    )
  },
  {
    categoryIds: [
      '29960', // Tablets and iPad
      '30621', // Fitness and activity trackers
      '1054684', // Nintendo Switch 2 consoles
      '812421', // PS5 consoles
      '812425', // Xbox Series X consoles
      '823765', // Xbox Series S consoles
      '30144', // smart watches
      '30293' // nintendo switch consoles
    ],
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  },
  {
    categoryIds: ['29953'], // Laptops and PCs
    excludedCategoryIds: ['30274'], // iMacs
    brand: 'Apple',
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  }
]

const hasMatchingCategory = (config, breadcrumbIds) => {
  return config.categoryIds.some(id => breadcrumbIds.includes(id))
}

const isExcludedCategory = (config, breadcrumbIds) => {
  if (!config.excludedCategoryIds) return false
  return config.excludedCategoryIds.some(excluded => breadcrumbIds.includes(excluded))
}

const isBrandMismatch = (config, brand) => {
  return config.brand && config.brand !== brand
}

/**
 * Finds the matching trade-in category configuration for a product
 * @param {Array} breadcrumb
 * @param {string} brand
 * @returns {Object|undefined}
 */
export const getMatchingTradeInCategory = (breadcrumb, brand) => {
  const breadcrumbIds = breadcrumb?.map(crumb => crumb.id) ?? []

  return tradeInCategoryConfig.find(config => {
    if (!hasMatchingCategory(config, breadcrumbIds)) return false
    if (isBrandMismatch(config, brand)) return false
    if (isExcludedCategory(config, breadcrumbIds)) return false
    return true
  })
}
